<script setup>
const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  choices: {
    type: Array,
    required: true,
  },
  choiceIds: {
    type: Array,
    required: true,
  },
  questionTitle: {
    type: String,
    required: true,
  },
  errors: {
    type: Object,
    required: true,
  },
  isMultipleChoice: {
    type: Boolean,
    required: true,
  }
});
const emits = defineEmits(['toggle-choice']);
</script>

<template>
  <div class="lyMb24">
    <div class="lyHorizontalBreak lyMb8">
      <p class="lyMr8 pFont12">{{questionTitle}}</p>
    </div>
    <p
      v-for="error in errors.value"
      class="lyMb8 pFont12 pFontMedium pFontRed">{{error}}</p>
    <ul>
      <li
        v-for="choice in choices"
        :key="choice.id"
        class="lyMb8"
      >
        <label class="pSelectAnswerLabel">
          <input
            :value="choice.id"
            :checked="choiceIds.includes(Number(choice.id))"
            :type="isMultipleChoice ? 'checkbox' : 'radio'"
            name="choice"
            @change="emits('toggle-choice', {id: choice.id, checked: $event.target.checked})"
          >
          <p class="lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontGreen pBackColorWhite pBorderRadius2px pSelectAnswerBtn">{{choice.title}}</p>
        </label>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.pSelectAnswerLabel input[type="checkbox"]:checked ~ .pSelectAnswerBtn {
  border-color: rgb(102,204,102);
}
</style>
